import React from 'react';
import QRCode from 'qrcode.react';
import { DOWNLOAD_APP_DOMAIN, APP_NAME } from "utils/Config";
import i18n from "I18n";
import { detectIsMobile } from 'utils';
import CustomButton from 'component/base/CustomButton';
import './NoWebappHappyDownloadPage.scss'

function DownloadPageMobile(props) {
    const isActionBar = props?.isActionBar
    const isMobile = detectIsMobile();
    if (!isMobile) {
        return null
    }
    return (
        <div className={`mobile-download-section`}>
            <label className='qrcode_message subheading'>
                {i18n.t("downloadAppToEarnReward")}
            </label>
            <CustomButton btnClicked={() => { window.open(DOWNLOAD_APP_DOMAIN) }} text={i18n.t("downloadApp")} className='download-btn-view' />
        </div>
    )
}

function DownloadPageWeb() {
    const isMobile = detectIsMobile();
    if (isMobile) {
        return null
    }
    return (
        <div className="web-download-section">
            <div className="qrcode_message subheading">
                {i18n.t("downloadAppToEarnReward")}
            </div>
            <div className="my_card_qrcode_view download_qrcode_view">
                <QRCode value={DOWNLOAD_APP_DOMAIN} renderAs="svg" />
            </div>
            <div className="download-btn-view">
                <button className="google_play_btn" disabled>
                    <img
                        alt="google play"
                        src="/googlePlay/google-play.png"
                        srcSet="/googlePlay/google-play@2x.png 2x, /googlePlay/google-play@3x.png 3x"
                    ></img>
                </button>
                <button className="apple_store_btn" disabled>
                    <img
                        alt="apple store"
                        src="/appleStore/appleStore.png"
                        srcSet="/appleStore/appleStore@2x.png 2x, /appleStore/appleStore@3x.png 3x"
                    />
                </button>
            </div>
        </div>
    )
}

export default function NoWebappMemberAccountCompletePage() {
    const isMobile = detectIsMobile();

    return <div className="no-webapp-download">
        <div>
            <img
                className='success-tick'
                alt="success"
                src="/campaignDetail/SuccessTick.png"
                srcSet="/campaignDetail/SuccessTick@2x.png 2x, /campaignDetail/SuccessTick@3x.png 3x"
            />
        </div>

        <div className="qrcode_message subheading">
            {i18n.t("accountCompletedSuccess")}
        </div>
        {isMobile ? <DownloadPageMobile /> : <DownloadPageWeb />}
    </div>
}